import PropTypes from "prop-types"

export const ITEM_SHAPE = PropTypes.shape({
  category: PropTypes.string,
  label: PropTypes.string,
  values: PropTypes.object,
})

export const VALUE_SHAPE = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.node,
])
